import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EarningRulesService } from 'src/app/services/earning-rules.service';

@Component({
  selector: 'app-list-target-regras',
  templateUrl: './list-target-regras.component.html',
  styleUrls: ['./list-target-regras.component.css']
})
export class ListTargetRegrasComponent implements OnInit {

  eventsSubject: Subject<any> = new Subject<any>();


  displayedColumns: string[] = ['name', 'targetRules', 'description', 'status', 'actions'];
  columnsToDisplay = [{field: 'name', header: 'Nome', type: 'text'}, {field: 'description', header: 'Descrição', type: 'text'}, {field: 'targetRules', header: 'Identificador', type: 'text'}];
  columnsObject = [];
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados:  [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: true, view: true, delete: true, statusUpdate: true};
  title = 'Target de Regras';
  novo = {link: '/target-regras/criar', nome: 'Novo Target Regra'};
  page: any = {base: null, name: null};
  service;

  constructor(private storeService: StoreService,
    private route: ActivatedRoute,
    private earningRulesService: EarningRulesService,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.earningRulesService.getAllTarget;
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.id } });
    }
    view = (args: any): void => {
      console.log(args);
      this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.id } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.earningRulesService.inactiveTarget(args.id);
      textConfirm = 'Pretende Desactivar o target Regra ' + args.name + '? Ao desactivar o TARGET o estado da TARGET será alterado para INATIVO e não aparecerá nos formulários.';
      status = 'INACTIVE';
      textShow = 'TARGET DEREGRA DESATIVADO COM SUCESSO';
    }
    else{
      service = this.earningRulesService.activeTarget(args.id);
      textConfirm = 'Pretende Activar o tipo de Regra ' + args.name + '? Ao activar o TARGET o estado do TARGET será alterado para ATIVO e aparecerá nos formulários';
      status = 'ACTIVE';
      textShow = 'TARGET ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar este TARGET ' + args.name + '? Ao eliminar os dados do TARGET serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.earningRulesService.deleteTarget(args.id).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }
